import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { AuthContextProvider } from "./context/authContext/AuthContext";
import { OrderContextProvider } from "./context/orderContext/OrderContext";
import { ClaimContextProvider } from "./context/claimContext/ClaimContext";
import { DashboardContextProvider } from "./context/dashboardContext/DashboardContext";
import { RegistrationContextProvider } from "./context/registrationContext/RegistrationContext";

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <RegistrationContextProvider>
        <DashboardContextProvider>
          <OrderContextProvider>
            <ClaimContextProvider>
              <App />
            </ClaimContextProvider>
          </OrderContextProvider>
        </DashboardContextProvider>
      </RegistrationContextProvider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
